<template>
  <div class="booking-block__footer">
    <div class="booking-block__footer-wrap">
      <a v-if="getPreviousStep" class="btn btn--white btn--white-hover booking-block__btn js-back-step-btn" @click="stepBack(getCurrentStep, $event)" href="javascript:">
        <span class="booking-block__btn-icon">
          <SvgIcon class="arrow-left-ico" iconName="ico-arrow-l"/>
        </span>
        <span class="booking-block__btn-name">
          Back
        </span>
      </a>
      <a v-else class="btn btn--white btn--white-hover booking-block__btn" :href="protocol + '//'+ hostname">
        <span class="booking-block__btn-icon">
          <SvgIcon class="arrow-left-ico" iconName="ico-arrow-l"/>
        </span>
        <span class="booking-block__btn-name">
          Back
        </span>
      </a>
      <a class="btn btn--white-hover booking-block__btn js-continue-step" @click="validateStep(getCurrentStep)" href="javascript:;">
        <span class="booking-block__btn-text js-continue-step-text">
          <span class="booking-block__btn-icon">
            <SvgIcon class="arrow-left-ico" iconName="ico-arrow-r"/>
          </span>
          <span class="booking-block__btn-name">
            Continue
          </span>
        </span>
        <div class="btn-loader js-btn-loader"></div>
      </a>
    </div>
  </div>
</template>

<script>
import Global from '../../../js/shared/global';
import {mapGetters} from 'vuex';
import Fancybox from '../../../js/site/fancybox';
import SvgIcon from '../base/SvgIcon/SvgIcon.vue';

export default {
  created() {
    // const entries = performance.getEntriesByType('navigation');
    // const entryType = entries.map(nav => nav.type);
    // // if is in array (use === if is not in array)
    // if (entryType.indexOf('back_forward') !== -1) {
    //   this.triggerValidateTime();
    //   this.$store.dispatch('setTotal', {often: '', oldOften: ''});
    // }
    const isBack = Global.readCookie('isBack');
    if (isBack) {
      if (isBack === true) {
        this.triggerValidateTime();
        this.$store.dispatch('setTotal', {often: '', oldOften: ''});
      }
    }
  },
  data() {
    return {
      protocol: location.protocol,
      hostname: location.hostname,
      addressObj: {},
    };
  },
  components: {
    SvgIcon
  },
  computed: {
    ...mapGetters([
      'getCurrentStep',
      'getPreviousStep',
      'getAllowedPostCodes',
      'getStepCount',
      'getCleaningType',
      'getProducts',
      'getSelectedDateObject',
      'getActiveProduct',
      'getDates',
      'getBedroom',
      'getBathroom',
      'getActiveFrequency',
      'getMultiDatesObj'
    ])
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    validateStep(step) {
      if (step === 'BlockStepLocation') {
        this.scrollToTop();
      }
      if (step === 'BlockStepSize') {
        this.setNewSteps(step);
        this.sendCleaningType();
        this.scrollToTop();
      }
      if (step === 'BlockStepOptions') {
        const val = this.validateOptions();
        if (!Array.isArray(val) && val) {
          this.setNewSteps(step);
          const howOften = Global.readCookie('howOften');
          this.$store.dispatch('setTotal', {often: '', oldOften: ''});
          this.scrollToTop();
        } else {
          // alert('Please select some cleaning type');
          const errorElem = document.querySelectorAll('.js-cleaning-error');
          for (let i = 0; i < errorElem.length; i++) {
            errorElem[i].style.display = 'block';
          }
          return false;
        }
      }
      if (step === 'BlockStepFrequency') {
        const isValid = this.checkFrequency();
        if (isValid) {
          this.setNewSteps(step);
          console.log(Global.readCookie('frequency'));
          if (Global.readCookie('frequency') === 1) {
            this.$store.dispatch('setTotal', {often: '', oldOften: ''});
          } else {
            this.$store.dispatch('setTotal', {often: Global.readCookie('howOften'), oldOften: ''});
          }

          this.scrollToTop();
        } else {
          // alert('Please select frequency');
          const errorElem = document.querySelectorAll('.js-cleaning-error');
          for (let i = 0; i < errorElem.length; i++) {
            errorElem[i].style.display = 'block';
          }
        }
      }
      if (step === 'BlockStepDates') {
        if (this.validateDates()) {
          this.setNewSteps(step);
          this.scrollToTop();
        }
      }
      if (step === 'BlockStepTime') {
        const isValid = this.validateTime();
        if (isValid) {
          this.setNewSteps(step);
          this.scrollToTop();
        }
      }
      if (step === 'BlockStepAddress') {
        const isValidLocation = this.validateLocation(step);
        const isValid = this.validateAddress();
        console.log(isValid);
        if (isValid && isValidLocation) {
          this.redirectToCheckout();
          this.scrollToTop();
        }

      }
    },

    stepBack(currentStepName, event) {
      event.preventDefault();
      const currentStep = document.querySelector(`.js-booking-step[id="${currentStepName}"]`);
      const prePreviousStep = document.querySelector(`.js-booking-step[id="${currentStepName}"]`).previousElementSibling.previousElementSibling;
      const previousStep = document.querySelector(`.js-booking-step[id="${currentStepName}"]`).previousElementSibling;
      const previousStepName = previousStep.getAttribute('id');
      const prePreviousStepName = prePreviousStep.getAttribute('id');
      this.$store.dispatch('setPreviousStep', prePreviousStepName);
      this.$store.dispatch('setCurrentStep', previousStepName);
      this.$store.dispatch('setNextStep', currentStepName);
      this.$store.dispatch('setStepCount', this.getStepCount === 1 ? 1 : this.getStepCount - 1);
      currentStep.style.display = 'none';
      previousStep.style.display = 'block';
      this.scrollToTop();
    },
    setNewSteps(currentStepName) {
      const currentStep = document.querySelector(`.js-booking-step[id="${currentStepName}"]`);
      const nextNextStep = document.querySelector(`.js-booking-step[id="${currentStepName}"]`).nextElementSibling.nextElementSibling;
      const nextStep = document.querySelector(`.js-booking-step[id="${currentStepName}"]`).nextElementSibling;
      const nextStepName = nextStep.getAttribute('id');
      const nextNextStepName = nextNextStep.getAttribute('id');
      this.$store.dispatch('setPreviousStep', currentStepName);
      this.$store.dispatch('setCurrentStep', nextStepName);
      this.$store.dispatch('setNextStep', nextNextStepName);
      const stepCounter = this.getStepCount + 1;
      const jumpStep = Global.readCookie('jumpStep');
      if (jumpStep) {
        if (parseInt(jumpStep) > this.getStepCount) {
          Global.deleteCookie('jumpStep');
          this.$store.dispatch('setStepCount', stepCounter);
        } else {
          Global.setCookie('jumpStep', parseInt(jumpStep) + 1);
        }
      } else {
        this.$store.dispatch('setStepCount', stepCounter);
      }
      currentStep.style.display = 'none';
      nextStep.style.display = 'block';
    },
    checkAddress() {
      Fancybox.init();
      const allowedCodes = this.getAllowedPostCodes.split(',');
      if (this.addressObj.postal_code === '' || !allowedCodes.includes(this.addressObj.postal_code)) {
        const popupTrigger = document.querySelector('.js-pu-re-trigger');
        popupTrigger.click();
        return false;
      } else {
        return true;
      }
    },
    checkFrequency() {
      return Global.readCookie('frequency');
    },
    validateLocation(step) {

      // set flag validation
      let flag = false;
      // get cookie address object so we can modified him
      const addressObj = Global.readCookie('address') ?? {};

      // all inputs form location
      const inputs = document.querySelectorAll('.js-booking-input');
      for (let i = 0; i < inputs.length; i++) {
        const error = inputs[i].parentElement.querySelector('.js-custom-step-error');
        const inputName = inputs[i].getAttribute('name');
        if (inputs[i].validationMessage !== '') {
          const error = document.createElement('span');
          error.classList.add('js-custom-step-error');
          error.classList.add('custom-step-error');
          error.innerText = inputs[i].validationMessage;
          inputs[i].parentElement.appendChild(error);
          flag = true;
        }
        if (inputs[i].validationMessage === '') {
          if (error) {
            error.remove();
          }
        }
        // set new value in address object
        addressObj[inputName] = inputs[i].value;
      }
      if (flag) {
        return;
      }
      // all fields are set
      // set new cookie
      Global.setCookie('address', addressObj);
      this.addressObj = addressObj;
      // next step
      return this.checkAddress();
    },
    validateOptions() {
      const activeCleaningTypeTab = document.querySelector('.js-type-tab.is-active');
      if (!activeCleaningTypeTab) {
        return false;
      }
      const activeCleaningTypeName = activeCleaningTypeTab.querySelector('.booking-steps__btn').innerText;
      const activeCleaningTypeTabDataId = activeCleaningTypeTab.getAttribute('data-id');
      const activeTab = jQuery('.booking-steps__wrap-bottom-box.tabcontent:visible');
      const activeExtras = activeTab[0].querySelectorAll('.js-extras-tabs.is-active');
      const activeExtrasIds = [];
      const activeChildrens = [];
      console.log(activeExtras);
      if (activeExtras) {
        for (let i = 0; i < activeExtras.length; i++) {
          // if (!activeExtras[i].classList.contains('is-active-included')) {
          //
          // }
          const activeExtrasDataId = activeExtras[i].getAttribute('data-id');
          const activeExtrasName = activeExtras[i].getAttribute('data-name');
          const activeExtrasVal = activeExtras[i].getAttribute('data-val');
          const obj = {
            'name': activeExtrasName,
            'val': activeExtrasVal,
            'included': activeExtras[i].classList.contains('is-active-included')
          };
          activeExtrasIds.push(activeExtrasDataId);
          activeChildrens.push(obj);
        }
      }
      const obj = {
        parent: activeCleaningTypeName,
        parentId: activeCleaningTypeTabDataId,
        childrenIds: activeExtrasIds,
        children: activeChildrens,
      };
      Global.setCookie('extraPriceTotal', obj);
      return this.getCleaningType;
    },
    validateDates() {
      const frequencyCookie = Global.readCookie('frequency');
      const selectedOneTimeDate = Global.readCookie('selectedOneTimeDate');
      const multiDates = Global.readCookie('multiDates');
      if (frequencyCookie === 2) {
        if (!multiDates) {
          // alert('Please select required fields.');
          const errorElem = document.querySelectorAll('#BlockStepDates .js-date-error');
          for (let i = 0; i < errorElem.length; i++) {
            errorElem[i].style.display = 'block';
          }
          return false;
        }
        if (Global.isEmptyObject(multiDates)) {
          alert('Please select required fields. 22');
          // const errorElem = document.querySelector('.js-date-error2');
          // errorElem.style.display = 'block';
          return false;
        }
        if (multiDates.requiredDays !== document.querySelectorAll('.js-days-checkbox.is-active').length) {
          // alert('Please select correct number of days (' + multiDates.requiredDays + ')');
          const errorElem = document.querySelector('#BlockStepDates .js-date-error2');
          const errorElement = document.querySelectorAll('#BlockStepDates .js-date-error');
          errorElem.style.display = 'block';
          errorElem.innerHTML = 'Please select correct number of days (' + multiDates.requiredDays + ')';
          //Check if elemError exists
          if (errorElem) {
            //Loop through all elements for errorElement
            for (let i = 0; i < errorElement.length; i++) {
              errorElement[i].style.display = 'none';
            }
          }
          return false;
        }
      }
      if (selectedOneTimeDate === '' || selectedOneTimeDate === null) {
        // alert('Please select the starting date.');
        const errorElem = document.querySelector('.js-date-error');
        errorElem.style.display = 'block';
        return false;
      }
      // const year = this.getSelectedDateObject?.year;
      // const month = this.getSelectedDateObject?.monthNumber;
      // const day = this.getSelectedDateObject?.day;
      // const id = this.getActiveProduct.id;
      // this.$store.dispatch('setAvailableTimeSingleBooking', 'wc_bookings_field_start_date_month=' + month + '&wc_bookings_field_start_date_day=' + day + '&wc_bookings_field_start_date_year=' + year + '&wc_bookings_field_start_date_time=&wc_bookings_field_start_date_local_timezone=&add-to-cart=' + id);
      return true;
    },
    validateTime() {
      const timeSlots = document.querySelector('.js-booking-steps__wrap-time-btn.is-active');
      if (!timeSlots) {
        // alert('Please select time slot! aa');
        const errorElem = document.querySelector('.js-date-error-time');
        errorElem.style.display = 'block';
        return false;
      } else {
        const productID = this.getCleaningType.productId;
        if (productID) {
          Global.setCookie('pid', productID);
        }
        // document.querySelector('.js-continue-step').classList.add('disabled');
        // document.querySelector('.js-btn-loader').classList.add('active-loader');
        // document.querySelector('.js-continue-step-text').classList.add('active-loader');
        // this.$store.dispatch('setBookingData', productID);
        return true;
      }
    },
    triggerValidateTime() {
      // document.querySelector('.js-btn-loader').classList.add('active-loader');
      // document.querySelector('.js-continue-step-text').classList.add('active-loader');
      // document.querySelector('.js-continue-step').classList.add('disabled');
      const productID = Global.readCookie('pid');
      // this.$store.dispatch('setBookingData', productID);
    },
    validateAddress() {
      const address = document.getElementById('booking-address');
      const apartment = document.getElementById('address2');
      const town = document.getElementById('locality');
      const state = document.getElementById('administrative_area_level_1');
      const postCode = document.getElementById('postal_code');
      const getIn = document.querySelector('.js-booking-steps__btn-first-row.is-active');
      const getInMessageKey = document.querySelector('.js-first-row-message-key');
      const getInMessageOther = document.querySelector('.js-first-row-message-other');
      const pets = document.querySelector('.js-booking-steps__btn-second-row.is-active');
      const petsMessage = document.querySelector('.js-second-row-message');
      const instructions = document.querySelector('.js-instructions-message');
      const obj = {
        'address': {
          'innerText': address ? address.value : '',
          'isValid': address ? address.value !== '' : '',
          'required': true
        },
        'apartment': {
          'innerText': apartment ? apartment.value : '',
          'isValid': apartment ? apartment.value !== '' : '',
          'required': true
        },
        'town': {
          'innerText': town ? town.value : '',
          'isValid': town ? town.value !== '' : '',
          'required': true
        },
        'state': {
          'innerText': state ? state.value : '',
          'isValid': state ? state.value !== '' : '',
          'required': true
        },
        'postCode': {
          'innerText': postCode ? postCode.value : '',
          'isValid': postCode ? postCode.value !== '' : '',
          'required': true
        },
        'getIn': {
          'innerText': getIn ? getIn.innerText : '',
          'isValid': !!getIn,
          'required': true
        },
        'getInMessageKey': {
          'innerText': getInMessageKey ? getInMessageKey.value : '',
          'isValid': getInMessageKey ? getInMessageKey.value !== '' : '',
          'required': getIn ? getIn.getAttribute('data-name') === 'key' : false,
        },
        'getInMessageOther': {
          'innerText': getInMessageOther ? getInMessageOther.value : '',
          'isValid': getInMessageOther ? getInMessageOther.value !== '' : false,
          'required': getIn ? getIn.getAttribute('data-name') === 'other' : false,
        },
        'pets': {
          'innerText': pets ? pets.innerText : '',
          'isValid': !!pets,
          'required': true
        },
        'petsMessage': {
          'innerText': petsMessage ? petsMessage.value : '',
          'isValid': petsMessage ? petsMessage.value !== '' : false,
          'required': pets ? pets.getAttribute('data-name') === 'other' : false,
        },
        'instructions': {
          'innerText': instructions ? instructions.value : '',
          'isValid': true,
          'required': false
        }
      };
      Global.setCookie('addressInfo', obj);
      // eslint-disable-next-line guard-for-in
      for (const key in obj) {
        if (!obj[key].isValid && obj[key].required) {
          // alert('Some fields are empty! aa');
          const errorElem = document.querySelectorAll('#BlockStepAddress .js-date-error');
          const errorOwgi = document.querySelector('.js-date-error-textarea-owgi');
          const errorKey = document.querySelector('.js-date-error-textarea-key');
          const errorPets = document.querySelector('.js-date-error-textarea-pets');
          for (let k = 0; k < errorElem.length; k++) {
            const isActive = errorElem[k].parentElement.querySelector('.booking-steps__btn.is-active');
            if (!isActive) {
              errorElem[k].style.display = 'block';
            }
            if (isActive) {
              console.log(isActive);
              if (isActive.getAttribute('data-name') === 'other' && isActive.classList.contains('js-booking-steps__btn-first-row')) {
                const otherText = document.querySelector('.js-first-row-message-other');
                if (otherText.value === '') {
                  errorOwgi.style.display = 'block';
                } else {
                  errorOwgi.style.display = 'none';
                }
              }
              if (isActive.getAttribute('data-name') === 'other' && isActive.classList.contains('js-booking-steps__btn-second-row')) {
                const otherText = document.querySelector('.js-second-row-message');
                if (otherText.value === '') {
                  errorPets.style.display = 'block';
                } else {
                  errorPets.style.display = 'none';
                }
              }
              if (isActive.getAttribute('data-name') === 'key') {
                const otherText = document.querySelector('.js-first-row-message-key');
                if (otherText.value === '') {
                  errorKey.style.display = 'block';
                } else {
                  errorKey.style.display = 'none';
                }
              }
            }

          }
          return false;
        }
      }
      this.$store.dispatch('setAddressInfo', obj);

      return true;
    },
    sendCleaningType() {
      const productID = this.getCleaningType.productId;
      if (productID) {
        const currentProduct = this.getProducts.filter(function(x) {
          if (x.id === productID) {
            return x;
          }
        });
        const activeBedroom = Global.readCookie('activeBedroom') ? Global.readCookie('activeBedroom') : '1';
        const activeBathroom = Global.readCookie('activeBathroom') ? Global.readCookie('activeBathroom') : '1';
        Global.setCookie('activeBedroom', parseInt(activeBedroom));
        Global.setCookie('activeBedroomObj', this.getCleaningType.bedrooms[parseInt(activeBedroom) - 1]);

        Global.setCookie('activeBathroom', activeBathroom);
        Global.setCookie('activeBathroomObj', this.getCleaningType.bedrooms[parseInt(activeBathroom) - 1]);

        Global.setCookie('activeBathroom', activeBathroom);
        Global.setCookie('activeBathroomObj', this.getCleaningType.bathrooms[parseInt(activeBathroom) - 1]);
        this.$store.dispatch('setActiveProduct', currentProduct[0]);
        this.$store.dispatch('setBathroom', currentProduct[0].bathrooms[parseInt(activeBathroom) - 1]);
        this.$store.dispatch('setBedroom', currentProduct[0].bedrooms[parseInt(activeBedroom) - 1]);

        const howOften = Global.readCookie('howOften');
        this.$store.dispatch('setTotal', {often: '', oldOften: ''});
      }
    },
    async redirectToCheckout() {
      document.querySelector('.js-continue-step').classList.add('disabled');
      document.querySelector('.js-btn-loader').classList.add('active-loader');
      document.querySelector('.js-continue-step-text').classList.add('active-loader');
      if (!Array.isArray(this.getCleaningType)) {
        Global.setCookie('cleaningTypeObj', this.getCleaningType);
      }
      const data = {
        'address': Global.readCookie('address'),
        'cleaningType': Global.readCookie('cleaningTypeObj'),
        'bedroom': Global.readCookie('activeBedroomObj'),
        'bathroom': Global.readCookie('activeBathroomObj'),
        'activeBedroom': Global.readCookie('activeBedroom'),
        'activeBathroom': Global.readCookie('activeBathroom'),
        'multiDates': Global.readCookie('multiDates'),
        'frequency': Global.readCookie('frequency'),
        'oneTimeDate': Global.readCookie('selectedOneTimeDate'),
        'time': Global.readCookie('selectedTime'),
        'addressInfo': Global.readCookie('addressInfo'),
        'startDate': Global.readCookie('selectedOneTimeDate'),
        'extras': Global.readCookie('extraPriceTotal'),
      };

      await this.$store.dispatch('setTransient', data);
    }
  }
};
</script>

<style lang="scss" scoped>
.booking-block__footer {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  background-color: $royal-blue;
  padding: 20px 15px;
  width: 100%;
  will-change: transform;
  z-index: 100;

  @include mq($xl) {
    padding: 20px 15px;
  }
}

.booking-block__footer-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1470px;
  width: 100%;
  margin: 0 auto;
}

.booking-block__btn {
  min-width: 260px;
  max-width: 260px;
  position: relative;

  span {
    transition: $dur $ease;
  }

  &.disabled {
    pointer-events: none;
  }

  @include mq($sm) {
    min-width: 200px;
    max-width: 200px;
  }

  @include mq($xs-phone) {
    min-width: 160px;
    max-width: 160px;
  }

  @include mq($xs) {
    max-width: 60px;
    min-width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 15px;
  }
}

.booking-block__btn-name {
  @include mq($xs) {
    display: none;
  }
}

.booking-block__btn-icon {
  font-size: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  display: none;
  transition: $dur $ease;

  &.active-loader {
    display: none;
  }

  @include mq($xs) {
    display: flex;
  }

  /deep/ svg {
    height: 20px;
  }
}
</style>
